

























import { computed, defineComponent, ref, toRefs } from '@nuxtjs/composition-api'
import { formFieldProps } from '~/constants/form'
import { useClassifiedForm } from '~/compositions/form'
import CTextArea from '~/components/shared/configurable/form/input/CTextArea.vue'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'
import FieldLanguagePicker from '~/components/car/classifieds/form/fieldsets/fields/FieldLanguagePicker.vue'
import { useMultiLanguagesForm } from '~/compositions/form/multi-language'
import { useDep } from '~/compositions/dependency-container'
import FormValidationBuilder from '~/builders/form/FormValidationBuilder'
import { debounce } from '~/utils/function'
import { DEBOUNCE_SLOWER } from '~/constants/debounce'

export default defineComponent({
  props: formFieldProps,
  components: { FieldLanguagePicker, FieldError, CTextArea },
  setup(props) {
    const { specs, name } = toRefs(props)

    const currentLanguage = ref('el')
    const languagesSpecs = computed(
      () =>
        specs.value?.languages || {
          el: { required: true },
          en: { required: false }
        }
    )
    const placeholder = computed(() => specs.value.placeholder)
    const currentLanguageError = computed(
      () => errors.value[currentLanguage.value]
    )
    const availableLanguages = computed(() => Object.keys(languagesSpecs.value))
    const maxLength = computed(() => specs.value.max)
    const minCharacters = computed(() => specs.value.min)

    const formValidationBuilder = useDep(FormValidationBuilder)

    function validate(lang: string, text: string) {
      errors.value[lang] = formValidationBuilder
        .new()
        .minCharsWithFeedback(minCharacters.value, text, true)
        .required(languagesSpecs.value[lang].required, text)
        .validate()
    }

    const { errors, values, onError, onValue } = useMultiLanguagesForm(
      languagesSpecs.value,
      validate
    )

    const { valueChanged } = useClassifiedForm(props, { onValue, onError })

    function setCurrentLanguage(lang: string) {
      currentLanguage.value = lang
    }
    function getLanguageValue(lang: string) {
      return values.value[lang] || null
    }
    function languageHasError(lang: string): boolean {
      return Boolean(errors.value[lang])
    }
    function languageIsSelected(lang: string) {
      return lang === currentLanguage.value
    }

    function handleInput(lang: string, text: string) {
      validate(lang, text)
      values.value[lang] = text
      updateValue(text, {
        multilingual: {
          abbreviation: currentLanguage.value
        }
      })
    }

    const updateValue = debounce(
      (value: any, options: any) => valueChanged(name.value, value, options),
      DEBOUNCE_SLOWER
    )

    return {
      maxLength,
      placeholder,
      availableLanguages,
      currentLanguageError,
      errors,
      languageIsSelected,
      languageHasError,
      setCurrentLanguage,
      getLanguageValue,
      handleInput,
      values,
      currentLanguage,
      languagesSpecs
    }
  }
})
